module.exports = __webpack_public_path__ + "static/media/Restriction_Enzyme_Haelli_RE.2af55a69.svg";